import React from 'react';

import LeaveStyleStudioEventNotificationView from './LeaveStyleStudioEventNotificationView';
import {
  useMessageData,
  useNotification,
} from '@components/Notification/hooks';

import { IEventNotification } from './interfaces';

const LeaveStyleStudioEventNotification = ({
  ref,
  id,
  message,
  type,
  onLeave,
  onCancel,
}: IEventNotification) => {
  const { hideNotification } = useNotification();
  const { color, colorIcon, background, icon } = useMessageData(type);

  const handleHide = () => hideNotification(id);

  return (
    <LeaveStyleStudioEventNotificationView
      ref={ref}
      message={message}
      color={color}
      colorIcon={colorIcon}
      icon={icon}
      background={background}
      onLeave={() => {
        handleHide();
        onLeave();
      }}
      onClickClose={() => {
        handleHide();
        onCancel();
      }}
    />
  );
};

export default LeaveStyleStudioEventNotification;
